import React from "react";
import { Layer, Marker, Source } from "react-map-gl/mapbox";
import * as turf from "@turf/turf";

const GpsCircle = ({ name, id, colour, coordinates_circle, showLabel=true }) => {
  // circleConfig = { center: [lng, lat], radius: 500 } // radius en metros

  //console.log(coordinates_circle);
  const { center, radius } = coordinates_circle;

  const centerCircle = [center.longitude, center.latitude];

  const circlePolygon = turf.circle(centerCircle, radius, {
    steps: 64, // más pasos = círculo más suave
    units: "meters",
  });

  const sourceId = `circle-source-${id}`;

  const fillLayer = {
    id: `circle-fill-${id}`,
    type: "fill",
    paint: {
      "fill-color": colour || "#00A",
      "fill-opacity": 0.3,
    },
  };

  const lineLayer = {
    id: `circle-line-${id}`,
    type: "line",
    paint: {
      "line-color": colour || "#00A",
      "line-opacity": 0.7,
      "line-width": 2,
    },
  };

  return (
    <Source id={sourceId} type="geojson" data={circlePolygon}>
      <Layer {...fillLayer} />
      <Layer {...lineLayer} />
      
      { showLabel && (
         <Marker
        key={name}
        longitude={centerCircle[0]}
        latitude={centerCircle[1]}
      >
        <div className="w-17 text-xs text-center bg-white bg-opacity-60 text-black rounded shadow px-1 py-1">
          {name}
        </div>
      </Marker>
      )

      }
     
    </Source>
  );
};

export default GpsCircle;
